const normalize = (value) => String(value || '').trim().toLowerCase();

export function getSubscriptionPaymentAction(subscription = {}) {
  const status = normalize(subscription.status);
  const providerStatus = normalize(subscription.provider_status);
  if (subscription.ended_at || status === 'ended' || ['canceled', 'cancelled', 'unpaid', 'incomplete_expired'].includes(providerStatus)) {
    return 'ended';
  }
  if (['past_due', 'payment_failed', 'incomplete'].includes(status) || providerStatus === 'past_due') {
    return 'recover';
  }
  if (['active', 'processing', 'trialing'].includes(status)) return 'manage';
  return 'unavailable';
}
